__turbopack_context__.v({
  "desktop": "BoardSectionKiAssistant-module-scss-module__VywATW__desktop",
  "iframe": "BoardSectionKiAssistant-module-scss-module__VywATW__iframe",
  "spacer": "BoardSectionKiAssistant-module-scss-module__VywATW__spacer",
});
